<template>
  <v-app>
    <app-navigation></app-navigation>

    <v-content id="content">
      <v-container fluid>
        <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-content>
    <app-alert></app-alert>
    <app-footer></app-footer>
  </v-app>
</template>

<style lang="stylus">
body {
  font-family: 'Lato', Helvetica, Arial, sans-serif !important;
}

#app {
  font-family: 'Lato', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.v--modal .v-application--wrap {
  min-height: auto;
}

.v--modal-overlay.scrollable .v--modal-box {
}

.v-card__text {
  padding: 0px;
}

/*
.v-card__text .v-window {
  width: 100%;
  height: 550px;
  overflow: scroll;
  padding: 0px 10px;
}

.v-card__actions {
  box-shadow: 0 -5px 15px -5px #666;
}
*/
.selected-tab {
  background: #DDD;
}
</style>
<script>
import Vue from "vue";
import fb from "./firebase";
import { mapState } from "vuex";

// import AppModal from "@/components/AppModal";
import AppAlert from "@/components/AppAlert";
import AppNavigation from "@/components/AppNavigation";
import AppFooter from "@/components/AppFooter";

export default {
  name: "App",
  components: {
    // AppModal,
    AppAlert,
    AppNavigation,
    AppFooter
  },
  computed: {
    ...mapState(["profile", "businesses", "plans"])
  },
  data() {
    return {};
  },
  mounted: function() {
    fb.db
      .collection("business_profiles")
      .orderBy("name", "asc")
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let businessIndex = this.businesses.findIndex(function(element) {
            return element.id === doc.id;
          });
          if (businessIndex === -1) {
            const business = Object.assign(
              {},
              { id: doc.id },
              {
                name: doc.data().name,
                code: doc.data().code,
                default_business_plan: doc.data().default_business_plan
              }
            );
            this.businesses.push(business);
          } else {
            const business = Object.assign(
              {},
              { id: doc.id },
              {
                name: doc.data().name,
                code: doc.data().code,
                default_business_plan: doc.data().default_business_plan
              }
            );
            this.businesses[businessIndex] = business;
          }
        });
      })
      .catch(() => {});
    // Update vuex plans array to get the new plans
    fb.db
      .collection("business_plans")
      .orderBy("code", "asc")
      .get()
      .then(snapshot => {
        let planArray = [];
        snapshot.forEach(doc => {
          const plan = Object.assign(
            {},
            {
              id: doc.id,
              name: doc.data().name,
              code: doc.data().code,
              business: doc.data().business
            }
          );
          planArray.push(plan);
        });
        this.$store.commit("setPlans", planArray);
      })
      .catch();
    fb.db
      .collection("user_profiles")
      .where("access_level", ">=", 5)
      .get()
      .then(snapshot => {
        let operatorArray = [];
        snapshot.forEach(doc => {
          const plan = Object.assign(
            {},
            { id: doc.id },
            { name: [doc.data().first_name, doc.data().last_name].join(" ") }
          );
          operatorArray.push(plan);
        });
        this.$store.commit("setOperators", operatorArray);
      })
      .catch();
    fb.auth.onAuthStateChanged(user => {
      if (user) {
        user
          .getIdToken()
          .then(token => {
            //console.log(token, user.uid, user.emailVerified);
            this.$store.commit("setUserToken", token);

            if (!this.$store.getters.getUserLanguage) {
              this.$store.commit("setUserLanguage", "fr");
            }

            Vue.http.headers.common[
              "Authorization"
            ] = `Bearer ${this.$store.getters.getUserToken}asdf`;
            Vue.http.headers.common[
              "Accept-Language"
            ] = this.$store.getters.getUserLanguage;
          })
          .catch(() => {
            //console.log("error getting id token", error);
          });
      } else {
        // User not logged-in
        this.$store.commit("setAppAlert", {
          visible: true,
          text: "This user has not enough privileges or they have been revoked."
        });
        this.$store.dispatch("userSignOut");
      }
    });

    fb.auth.onIdTokenChanged(user => {
      if (user) {
        // User is signed in or token was refreshed.
        user
          .getIdToken()
          .then(token => {
            //console.log("Refreshed token", token);
            this.$store.commit("setUserToken", token);

            Vue.http.headers.common[
              "Authorization"
            ] = `Bearer ${this.$store.getters.getUserToken}`;
            Vue.http.headers.common[
              "Accept-Language"
            ] = this.$store.getters.getUserLanguage;

            //this.$store.dispatch("getUserProfile");
          })
          .catch(() => {
            //console.log("error getting id token", error);
          });
      } else {
        // User not logged-in
        this.$store.commit("setAppAlert", {
          visible: true,
          text: "This user has not enough privileges or they have been revoked."
        });
        this.$store.dispatch("userSignOut");

        //console.log("user not defined");
      }
    });
  },
  watch: {
    profile(val) {
      if (val && val.id && val.id !== "") {
        //console.log(val);
        // Set a onsnapshot event on user profile to check for his permissions in real time
        fb.profiles.doc(val.id).onSnapshot(
          snapshot => {
            if (snapshot.data()) {
              if (snapshot.data().access_level < 5) {
                this.$store.commit("setAppAlert", {
                  visible: true,
                  text:
                    "This user has not enough privileges or they have been revoked."
                });
                this.$store.dispatch("userSignOut");
              }
            }
          },
          () => {
            //console.log("not allowed", error);
          }
        );
      }
    }
  }
};
</script>
